import noImage from "@/assets/noimage.png";

export default function(flower) {
  if (flower.images.length > 0) {
    return flower.images[0].image_url;
  }
  return noImage;
}
